import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/fi/cafes";

export const Route = createFileRoute("/fi/cafes/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("cafes")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "fi",
      loaderData,
      fallbackTitle: 'Kahvilat Suomessa — kahvia ja leipomoita | what Finland',
      fallbackDescription: 'Suomalaiset kahvilat ja leipomot alueittain, aukioloaikoineen.',
      listName: 'Kahvilat Suomessa',
    }),
  component: () => <HubIndexPage slug="cafes" locale="fi" />,
});
